import clsx from 'clsx';
import Icon from 'ui/Icon/Icon';
import './LinkIcon.scss';

type LinkIconProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

const LinkIcon: React.FC<LinkIconProps> = ({
  className,
  children,
  ...props
}) => {
  return (
    <div {...props} className={clsx('link-icon', className)}>
      <Icon>
        {children}
      </Icon>
    </div>
  );
}

export default LinkIcon;